import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {EmployeesState} from '@local/redux/state/pages/employees';

// 初期ステートをこういう感じにするとページ増えたときのredux層の情報量が増えるけど
// 数百万件とか裁こうとしてる中でこういうのが多少あってもそもそも変わらんし
// ページ遷移時の遅延がない（最初から初期状態は持ってる）ほうがいいし
// stateなし、初期ロード前、ロード後の3段階管理する複雑さによる開発への影響と
// その結果の品質への影響のほうが大きいので、こうする。
const initialState: EmployeesState = {
  init: false,
  countFrom: 0,
  countTo: 0,
  totalCount: 0,
  page: 1,
  pageFrom: 1,
  pageTo: 1,
  totalPage: 1,
  rows: [],
  checked: [],
  checkAll: false,
  checkExcludes: [],
  processing: false,
};
const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<EmployeesState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setSortOption: (state, action: PayloadAction<Partial<EmployeesState['sortState']>>) => {
      return {
        ...state,
        sortState: {
          ...state.sortState,
          ...action.payload,
        },
      };
    },
    clear: () => initialState,
  },
});
export const employeesReducer = employeesSlice.reducer;
export const employeesActions = employeesSlice.actions;
